import React from "react";
import { DialogActions, Typography, Button, Box } from "@material-ui/core";
import { platforms } from "./Platforms";
import {
  IOSShareIcon,
  FireFoxA2HSIcon,
  MenuIcon,
  OperaA2HSIcon,
} from "./Icons";

function DialogActionWithInstructions(props) {
  return (
    <Box width="100%" display="flex" flexDirection="column">
      <Box>
        <Typography variant="subtitle1">Para instalar esse App:</Typography>
        <ul>
          <li>
            <span style={{ display: "flex", alignItems: "center" }}>
              {props.action1}
            </span>
          </li>
          <li>{props.action2}</li>
        </ul>
      </Box>
      <Box width="100%" textAlign="right">
        <Button onClick={props.onSubmit}>Ok</Button>
      </Box>
    </Box>
  );
}

export default function InstallDialogAction(props) {
  return (
    <>
      <DialogActions>
        {props.platform === platforms.NATIVE && (
          <>
            <Button onClick={props.onClose}>Cancelar</Button>
            <Button
              onClick={props.onSubmit}
              color="primary"
              variant="contained"
              disableElevation
            >
              Instalar
            </Button>
          </>
        )}
        {props.platform === platforms.IDEVICE && (
          <DialogActionWithInstructions
            action1={
              <>
                Toque no botão de compartilhar:
                <IOSShareIcon />
              </>
            }
            action2="Então encontre e toque em 'Tela de Início'"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.FIREFOX && (
          <DialogActionWithInstructions
            action1={
              <>
                Toque no icone na barra de endereço:
                <FireFoxA2HSIcon />
              </>
            }
            action2="então toque em '+Adicionar na tela'"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.FIREFOX_NEW && (
          <DialogActionWithInstructions
            action1={
              <>
                Toque no butão menu:
                <MenuIcon />
              </>
            }
            action2="então toque em 'Instalar'"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.OPERA && (
          <DialogActionWithInstructions
            action1={
              <>
                Toque no butão menu:
                <MenuIcon />
              </>
            }
            action2={
              <>
                então toque &nbsp;'
                <OperaA2HSIcon />
                Tela Inicial'
              </>
            }
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.OTHER && (
          <Box width="100%" display="flex" flexDirection="column">
            <Box>
              Infelizmente a funcionalidade de instalação não é suportada por
              esse navegador.
            </Box>
            <Box width="100%" textAlign="right">
              <Button onClick={props.onClose}>Ok</Button>
            </Box>
          </Box>
        )}
      </DialogActions>
    </>
  );
}
